/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 function calculate_height() {
   var biggestHeight = 0;
  $('.ProductRecommendations .slick-slide').each(function (index, element) {
      var currentBoxHeight = $(this).outerHeight(); 
      biggestHeight = currentBoxHeight >= biggestHeight ? currentBoxHeight : biggestHeight;
  });
  $('.ProductRecommendations .slick-slide').css('height', biggestHeight + 'px');
  
   var biggestHeight_new = 0;
  $('.recently-viewed-products .slick-slide').each(function (index, element) {
      var currentBoxHeight_new = $(this).outerHeight(); 
      biggestHeight_new = currentBoxHeight_new >= biggestHeight_new ? currentBoxHeight_new : biggestHeight_new;
  });
  $('.recently-viewed-products .slick-slide').css('height', biggestHeight_new + 'px');
 }
$(document).on('change', '.qsb-form__inner select', function(){
    var get_id = $("select.qsc-d-none.qsb-master-select option:selected").val();
    $(".no-js.ProductForm__Option select option").val(get_id).change();
    console.log(get_id);
});
            setTimeout(function() {
        $(".qsc-btn--add-to-cart").on("click",function(e) {
e.preventDefault();
   $(".ProductForm__AddToCart").trigger('click');
});
                    }, 5000);

$(document).on('change', '.upsell-product-list-slider .product-list .select__select', function(){
  var get_image = $(this).find('option:selected').data('image'); 
  if(get_image != ''){
    $(this).parents('.product-list').find('.image-element__wrap img').attr('src',get_image);
  }
});
$(document).ready(function() {
    var get_btn_text = $('.free-product-text-btn').val();
    var get_offer_text = $('.free-product-product-offer-txt').val();
    var get_offer_text3 = $('.free-product-product-offer-txt3').val();

    var index_button_text = $('.index-product-button-text').val();
    var upsell_price_footer = $('.free_price-wraper-footer-upsell').val();
        
    if(get_btn_text != undefined && get_btn_text != '' ){
    $('.Drawer__Footer-upsell-collection .cart-add-btn span.text.addcart-txt').html(get_btn_text);
 //   $('.ProductItem .custom_button_wrapper').html(get_btn_text);
   if(upsell_price_footer != undefined && upsell_price_footer != '' ){
       $('.Drawer__Footer-upsell-collection .product-details span.price.sale').html('<span class="money">'+upsell_price_footer+'</span>');  
    }
      if(index_button_text != undefined && index_button_text != '' ){
     // $('.ProductItem .custom_button_wrapper').html(index_button_text);
    }
      if(get_offer_text != undefined && get_offer_text != '' ){
     //  $('.offer_text_wrapper').html(get_offer_text);
    //    $(".get_offer_text3").html(get_offer_text3);
    }else{
      var remove_br = get_btn_text.replace('<br/>',' ');
    //  $('.offer_text_wrapper').html(remove_br);
     }
    }
});
  function timer_customfuntion(){
  var get_old_time = localStorage.getItem('timer_time');
  if(get_old_time != null){
  
  var deadline = new Date(get_old_time).getTime();
  
  }else{
      var date = new Date();
      var monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var dayName = days[date.getDay()];
      var get_month_name = monthNames[date.getMonth()];
      var current_date = dayName+" "+get_month_name+" "+date.getDate()+" "+ date.getFullYear();
      var next_hr = date.getHours();
      var currentTime = new Date().getTime();
      var  updatedTIme = new Date(currentTime + 24219000);
      var current_time = next_hr+":"+date.getMinutes()+":"+ date.getSeconds();
      var date_time = current_date+" "+updatedTIme; 
      console.log(updatedTIme);
      localStorage.setItem('timer_time', updatedTIme);
      var deadline = new Date(updatedTIme).getTime();
  }
  var x = setInterval(function() {
  var now = new Date().getTime();
  var t = deadline - now;
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60));
  var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((t % (1000 * 60)) / 1000);
  
      $('#countdown-hr').html(('0' + hours).slice(-2));
      $("#countdown-min").html(('0' + minutes).slice(-2));
      $("#countdown-sec").html(('0' + seconds).slice(-2));
      $(".cart-timer-hr").html(('0' + hours).slice(-2));
      $(".cart-timer-min").html(('0' + minutes).slice(-2));
      $(".cart-timer-sec").html(('0' + seconds).slice(-2));
  
          $(".timeHours .timeNum").html(('0' + hours).slice(-2));
      $(".timeMins .timeNum").html(('0' + minutes).slice(-2));
      $(".timeSec .timeNum").html(('0' + seconds).slice(-2));
    
    if (t < 0) {
        clearInterval(x);
  
      var date = new Date();
      var monthNames = ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"];
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      var dayName = days[date.getDay()];
      var get_month_name = monthNames[date.getMonth()];
      var current_date = dayName+" "+get_month_name+" "+date.getDate()+" "+ date.getFullYear();
      var next_hr = date.getHours();
      var currentTime = new Date().getTime();
      var  updatedTIme = new Date(currentTime + 24219000);
      var current_time = next_hr+":"+date.getMinutes()+":"+ date.getSeconds();
      var date_time = current_date+" "+updatedTIme; 
      console.log(updatedTIme);
      localStorage.setItem('timer_time', updatedTIme);
      
      timer_customfuntion();
        // document.getElementById("demo").innerHTML = "EXPIRED";
    }
  }, 1000);
  }
  timer_customfuntion();
function gift_card(){
jQuery.getJSON('/cart.js', function(cartData) {
     var data = cartData.total_price;
      var  existid = 39476652966022;
      var exist = 0;
      for (let i = 0; i < cartData.items.length; i++) {
        var itemvid = cartData.items[i]['id'];
        if(itemvid == existid ){
          exist = 1;
        }
        
      }
      if(data > 0){
        if(exist == 0){

               $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data:{
                  id: 39476652966022,
                  quantity: 1
                },
                dataType: 'json',
                success: function(data) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
       }));
                },
               });
            
        }
      }else{
          if(exist == 1){
                       $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data:{
                  id: 39476652966022,
                  quantity: 0
                },
                dataType: 'json',
                success: function(data) {
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
       }));
                },
               });
          }
      } 
     
    });
}

$(document).on('click','.add_to_cart_wrap', function(){
var variant_id = $(this).attr('data-id');
$(this).find('.button_add_text').text('✔️המוצר נוסף');

   data = {
      "id": variant_id,
      "quantity": 1
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(data) { 
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
         }));
$(this).find('.button_add_text').text('🛒 הוספה לסל הקניות');

$("a.Header__Icon.Icon-Wrapper[data-drawer-id='sidebar-cart'] svg.Icon.Icon--cart-desktop").parent().trigger('click');
      }
    });
});

$(document).on('click','.Drawer__Footer-upsell-collection .purchase-details .cart-add-btn', function(){
    console.log('working');
    $(this).find('.addcart-txt').text('Added!');

  var variant_id = $(this).parents('.product-wrap').find('.product-form__input .select__select').val();
  console.log(variant_id);
   data = {
      "id": variant_id,
      "quantity": 1
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(data) { 
          $(this).find('.free-text').text('Added!');
          $(this).find('.addcart-txt').text('Add to cart');

        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true  //this code is for prestige theme, is to refresh the cart
         }));
      }
    });
});
function my_function_onscroll(event){
var get_geight = $('#sidebar-cart').find(".Drawer__Main").height();
var get_geight2 = $('#sidebar-cart .Drawer__Footer').find(".cart-bottom-position").height();
var get_geight3 = get_geight + get_geight2;
   var e = $(event).scrollTop();
  if(e > 10){
   $('.sticky_checkout').show();   
   $('.custom_checkout_wrapper_main').hide();
  }else{
   $('.sticky_checkout').hide();
   $('.custom_checkout_wrapper_main').show();
  }

  
}
$(document).ready(function() {
  if($(window).width() < 1008){ 
    console.log('working');
     $('.ProductRecommendations .ProductList--carousel').slick({
      dots: false,
      arrows:true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
       ]
    });
    $('div#shopify-section-template--14562858958982__recently-viewed-products .ProductList--carousel').slick({
      dots: false,
      arrows:true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
       ]
    });
  }
  calculate_height();
  $(window).resize(function(){
   calculate_height();
  });
});
$(document).on('click','.action_button.add_to_cart', function(){
$(this).find('.addcart-txt2').text('✔️המוצר נוסף');
    var $this = $(this);
                setTimeout(function() {
                $this.find('.addcart-txt2').text('🛒 הוספה לסל');
   
}, 2500);
    
});
$(document).on('click','.sticky-addcartbtn.size-increase', function(){

$(".sticky-addcartbtn.size-increase").text('✔️המוצר נוסף');
    
                setTimeout(function() {
                 $(".sticky-addcartbtn.size-increase").text('🛒הוספה לסל הקניות');
   
}, 2500);
    
});

$(document).on('click','.cart_drawer_section_upsell .title-wrapper', function(){

$(".cart_drawer_section_upsell .title-wrapper").removeClass('active');
    $(this).addClass('active');
    var get_title = $(this).attr('data-handle');
                                 $(".upsell_coll_wrap.wave_section_inner").removeClass('active');
    $(".upsell_coll_wrap.wave_section_inner[data-handle="+get_title+"]").addClass('active');
                          
});